import { configureStore } from '@reduxjs/toolkit';
import chatBotReducer from '../features/chatbot/store/ChatBotStore.ts';

export const store = configureStore({
    reducer: {
        chatbot: chatBotReducer,

    },
    
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
